import { useAuth } from '@/auth/auth-context';
import { PLATFORM_TIMEZONE, platformTimezone, setPlatformTimezone } from './time';

/**
 * The platform timezone, taken from the server and pushed into `time.ts`.
 *
 * It rides along on `/auth/me`, which this app already fetches before it draws
 * anything, so it costs no request and is in place before the first date is
 * rendered. There is no setter: the server owns the value, because the server
 * is what compares a shop's stored `09:00` against the current moment. A till
 * that picked its own zone could show a schedule the marketplace does not act
 * on, which is the exact failure this whole change exists to remove.
 */
export function usePlatformTimezoneSync(): string {
  const { user } = useAuth();
  const zone = user?.platformTimezone ?? PLATFORM_TIMEZONE;

  // During render on purpose: an effect would let the first paint of every
  // page below this one go out on the previous zone.
  if (zone !== platformTimezone()) setPlatformTimezone(zone);

  return platformTimezone();
}
